import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-900">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="text-xl font-heading font-bold text-background-50">91视频</span>
            </Link>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              {t('footer.slogan')}
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">{t('nav.category')}</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/movie" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">热门影视</Link>
              <Link to="/category/short" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">短视频</Link>
              <Link to="/category/variety" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">综艺娱乐</Link>
              <Link to="/category/anime" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">动漫动画</Link>
              <Link to="/category/documentary" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">纪录片</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">{t('footer.about')}</Link>
              <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">{t('footer.privacy')}</a>
              <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">{t('footer.terms')}</a>
              <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">{t('footer.contact')}</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">{t('about.contactTitle')}</h4>
            <div className="flex flex-col gap-2 text-sm text-background-400">
              <p>contact@91video.com</p>
              <p>400-888-9191</p>
              <p>北京市朝阳区望京科技园A座</p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">{t('footer.copyright')}</p>
          <p className="text-xs text-background-600">京ICP备2024000001号 | 网络视听许可证0100001号</p>
        </div>
      </div>
    </footer>
  );
}